import * as React from 'react';

interface ViewProps {
    name: string;
}

const View = ({ children }: React.PropsWithChildren<ViewProps>): React.ReactElement => (
    <>{children}</>
);

export default View;
